
const ContentTooltip = ({ tooltip ='', children, dottedHighlight = true, margin = '0 1rem 0 0' }) => 
    <div className="content-hoverable" style={{ display: 'inline-block', position: 'relative', cursor: 'pointer', borderBottom: dottedHighlight ? '.15rem dotted #000' : 'none', margin }}>
        {children}
        {tooltip && (
            <div className="tooltip">
                {tooltip}
            </div>
        )}
    </div>;

export default ContentTooltip;